import firebase from "firebase";
import conf_real from "../config.real.json";
import conf_dev from "../config.dev.json";

let conf;

var isDev = true;

switch (window.location.hostname) {
    case 'yahac-dev.firebaseapp.com':
    case 'yahac.ga':
    case 'localhost':
        isDev = true;
        break;
    default:
        isDev = false;

}

// if (process.env.NODE_ENV === 'production') {
if (isDev) {
    conf = conf_dev;
} else {
    conf = conf_real;
}
window.UPLOADCARE_PUBLIC_KEY = conf.uploadcare.UPLOADCARE_PUBLIC_KEY;
firebase.initializeApp(conf.firebase);
window.firebase = firebase;
export const config = conf;
export default firebase;


// WEBPACK FOOTER //
// ./src/lib/firebase.js